import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10398914"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menu-manage-container"
};
import { ref } from 'vue';
import MenuFilterBlock from './components/MenuFilterBlock.vue';
import MenuTableBlock from './components/MenuTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuManagement',
  setup(__props) {
    const tableRef = ref(null);
    const filterSubmit = params => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(params);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MenuFilterBlock, {
        onFilterSubmit: filterSubmit
      }), _createVNode(MenuTableBlock, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});